import React, { Component } from "react";
import Divider from "../../common/divider";
import PageTitle from "../../common/pageTitle";
import Toaster from "toastr";
import Breadcrumbs from "react-breadcrumbs";
import Constants from "../../../configurations/constants";
import Messages from "../../../configurations/messages";
import DisputesAPI from "../../../api/DisputesApi";
import Util from "../../../util/util";
import SelectDropdown from "../disputes/DisputeSelectDropdown";
import ArbiterApi from "../../../api/ArbiterApi";
import Urls from "../../../configurations/urls";
import { browserHistory } from "react-router";
import RouteConfig from "../../../configurations/routesConfig";
class BulkDecline extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      categories: [],
      category: null,
      loading: false,
      base64Journal: "",
      base64Details: "",
      fileSize : 0,
    };
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.handleJournalFileChange = this.handleJournalFileChange.bind(this);
    this.handleDetailsFileChange = this.handleDetailsFileChange.bind(this);
  }
  getDisputeCategories = (cb) => {
    ArbiterApi.getDisputeBulkDeclineCategories()
      .then((response) => {
        let categories = response.data.map((obj) => {
          obj.label = obj.category;
          obj.value = obj.category;
          obj.statuses = obj.statuses.map((status) => {
            return {
              label: status,
              value: status,
            };
          });
          return obj;
        });
        if (cb) cb();
        this.setState({ categories });
      })
      .catch((error) => {
        if (cb) cb();
        Util.errorMessageToast(Toaster, error.data, [
          ` ${Messages.ERROR_DISPUTE_CATEGORIES}`,
        ]);
      });
  };

  acceptDeclineHandler = (status) => {
    this.setState({ actionLoading: true }, () => {
      const body = {
        category: this.state.params.category,
        action: status,
        logCodes: [...this.state.selection],
      };
      DisputesAPI.acceptOrDeclineBulkDisputes(body)
        .then((response) => {
          this.onSearchHandler(this.state.params, true);
          Toaster.success(
            `Bulk Dispute ${status} request has been succefully submitted for processing.`
          );
          this.setState({ actionLoading: false });
        })
        .catch((error) => {
          Util.errorMessageToast(Toaster, error.data, [
            `${Messages.ERROR_BULK_DISPUTES_UPDATE}`,
          ]);
          this.setState({ actionLoading: false });
        });
    });
  };

  declineBulkDispute = () => {
    this.setState({ loading: true });

    const payload = {
      category: this.state.category.category,
      details: this.state.base64Details,
      journals: this.state.base64Journal,
    };

    DisputesAPI.declineBulkDispute(payload)
      .then((response) => {
        Toaster.success(
          `Bulk Dispute Decline request has been succefully submitted for processing.`
        );
        this.setState({ loading: false });
        browserHistory.push(RouteConfig.DISPUTE_UPDATE_STATUS_ROUTE.path);
      })
      .catch((error) => {
        this.setState({ loading: false });
        Util.errorMessageToast(Toaster, error.data.code, [
          error.data.description,
        ]);
      });
  };

  handleJournalFileChange(event) {
  
    let target = event.target;
    if (target.files[0]) {
      const sizeInMB = (target.files[0].size / (1024 * 1024)).toFixed(2);
      this.setState({fileSize : sizeInMB})
    }
    const reader = new FileReader();
    reader.readAsDataURL(target.files[0]);
    reader.onload = () => {
      const base64String = reader.result.split(",")[1];
      this.setState({ base64Journal: base64String });
    };
    reader.onerror = (error) => {
      console.error("Error occurred while reading file:", error);
    };
  }

  handleDetailsFileChange(event) {
    let target = event.target;

    const reader = new FileReader();
    reader.readAsDataURL(target.files[0]);
    reader.onload = () => {
      const base64String = reader.result.split(",")[1];
      this.setState({ base64Details: base64String });
    };
    reader.onerror = (error) => {
      console.error("Error occurred while reading file:", error);
    };
  }

  handleCategoryChange(evt) {
    this.setState({
      category: evt,
    });
  }

  render() {
    const category = this.state.category || {};
    return (
      <div>
        <div id="page-breadcrumb" className="breadcrumb-container">
          <Breadcrumbs
            separator={Constants.BREADCRUMB_SEPARATOR}
            routes={this.props.routes}
            params={this.props.params}
          />
        </div>
        <PageTitle title="Bulk Decline" />
        <Divider />
        <div className="row bulk-template">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-3">
                <label className="input-control-label required">Category</label>

                <SelectDropdown
                  placeholder="Category"
                  onChange={this.handleCategoryChange}
                  options={this.state.categories}
                  value={this.state.category}
                  disabled={false}
                  loadOptions={this.getDisputeCategories}
                />
              </div>
              <div className="col-md-3">
                <br />
                <a
                  href={`${Urls.ARBITER_BASE_PATH}${Urls.ARBITER_API_BASE_PATH}${Urls.ARBITER_API_DISPUTES_DECLINE_TEMPLATE}?disputeCategory=${category.value}`}
                  className="button btn btn-primary long-btn"
                  target={this.disableControl() ? "" : "_blank"}
                  disabled={this.disableControl()}
                >
                  Download Template
                </a>
              </div>
            </div>
          </div>
        </div>
        <Divider />

        <div className="row">
          <div className="col-md-3">
            <div className="section">
              <label className="input-control-label required">
                Upload Journal
              </label>
              <input
                className="form-control float_input"
                accept=".zip"
                type="file"
                ref="journal"
                id="journal"
                name="journal"
                style={{ width: "100%" }}
                onChange={this.handleJournalFileChange}
              />
              <small className="text-info" style={{ marginTop: "70px" }}>
                * File Format Allowed: ZIP File
              </small>
              <br />
              <small className="text-info">
                * Maximum File Size Allowed:{" "}
                 8 MB
              </small>
            </div>
          </div>
          <div className="col-md-3">
            <div className="section">
              <label className="input-control-label required">
                Upload File
              </label>
              <input
                accept=".xls"
                className="form-control float_input"
                type="file"
                ref="detailsFile"
                id="detailsFile"
                name="detailsFile"
                style={{ width: "100%" }}
                onChange={this.handleDetailsFileChange}
              />
              <small className="text-info" style={{ marginTop: "70px" }}>
                * File Format Allowed: Microsoft Excel [XLS]
              </small>
            
            </div>
          </div>
          <div className="col-md-3">
            <br />{" "}
            <button
              className="btn btn-primary long-btn"
              onClick={this.declineBulkDispute}
              disabled={this.disableUploadControl() || this.state.loading}
            >
              Decline
            </button>
          </div>
          {this.state.loading && (
            <div className="full-loading">
              <div className="loader"></div>
            </div>
          )}
        </div>
        <Divider />
      </div>
    );
  }

  disableControl() {
    return !this.state.category;
  }
  disableUploadControl() {
    return !(
      this.state.category &&
      this.state.base64Details &&
      this.state.base64Journal &&
      this.state.fileSize <= 8
    );
  }
}
export default BulkDecline;



// WEBPACK FOOTER //
// ./src/components/disputeMgmt/bulk_dispute_decline/BulkDecline.js